// dashboard/modals/VCPRAttestationModal.js
// Legal-risk audit (2026-09-10), finding #2. Copy is Bryan's exact
// approved language (2026-09-10) -- do not edit without his sign-off.
// Shown before the existing assign-workflow flow for any pending
// enrollment that has never been VCPR-attested (App.js gates on
// pet.vcprAttestedAt). Restricted server-side to an active Doctor at the
// pet's own clinic (attest_vcpr RPC, migration 215) -- a Manager cannot
// make this attestation. Clicking the primary button IS the attestation
// -- no separate checkbox, matching Bryan's exact spec.

import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { c } from '../constants';
import { useModalA11y } from '../useModalA11y';
import { supabase } from '../../supabase';
import { VCPR_ATTESTATION_VERSION } from '../../legalDocumentVersions';

export default function VCPRAttestationModal({ pet, onAttested, onCancel }) {
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const containerRef = useModalA11y(onCancel);

  const handleConfirm = async () => {
    if (saving) return;
    setSaving(true); setError('');
    try {
      const { data, error: rpcErr } = await supabase.rpc('attest_vcpr', {
        p_relationship_id: pet.relationshipId,
        p_version: VCPR_ATTESTATION_VERSION,
      });
      if (rpcErr) throw rpcErr;
      if (!data?.attested) throw new Error(t('vcprAttestation.error'));
      onAttested();
    } catch (err) {
      setError(err.message || t('vcprAttestation.error'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(79,100,115,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
      <div
        ref={containerRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="vcpr-modal-title"
        style={{ backgroundColor: c.white, borderRadius: 16, padding: 28, width: '100%', maxWidth: 460, boxShadow: '0 8px 32px rgba(79,100,115,0.18)', outline: 'none' }}
      >
        <h2 id="vcpr-modal-title" style={{ fontSize: 17, fontWeight: 600, color: c.slate, marginBottom: 14 }}>{t('vcprAttestation.title')}</h2>
        <p style={{ fontSize: 13, color: c.slate, lineHeight: 1.6, marginBottom: 20, whiteSpace: 'pre-line' }}>{t('vcprAttestation.statement')}</p>

        {error && <p role="alert" style={{ fontSize: 12, color: c.error, marginBottom: 12 }}>{error}</p>}

        <button
          onClick={handleConfirm}
          disabled={saving}
          style={{ width: '100%', padding: '12px', backgroundColor: c.moss, color: c.white, border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: saving ? 'default' : 'pointer', opacity: saving ? 0.6 : 1, marginBottom: 12 }}
        >
          {saving ? t('common.saving') : t('vcprAttestation.confirm')}
        </button>
        <button
          onClick={onCancel}
          disabled={saving}
          style={{ display: 'block', width: '100%', padding: '4px', background: 'none', border: 'none', fontSize: 13, fontWeight: 500, color: c.textSoft, cursor: saving ? 'default' : 'pointer', textAlign: 'center' }}
        >
          {t('vcprAttestation.cancel')}
        </button>
      </div>
    </div>
  );
}
